import styled from "@emotion/styled";
import { Box, ListItem, ListItemButton, Typography } from "@mui/material";
import theme from "../../../theme";
import { HEADER_AND_TAB_HEIGHT } from "../../ChatInfo.style";

export const LabRequisitionsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: calc(100dvh - ${HEADER_AND_TAB_HEIGHT}px);
  padding: 12px;
`;

export const LabRequisitionsTitleContainer = styled(Box)`
  margin-left: 12px;
  padding: 12px 0;
`;

export const LabRequisitionCard = styled(Box)`
  display: flex;
  align-items: center;
  height: 54px;
`;

export const LabRequisitionButton = styled(ListItemButton)`
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  cursor: auto;
  border: 1px solid ${theme.palette.grey[300]};
  padding: 10px 16px 10px 16px;
  margin-bottom: 2px;
  border-radius: 4px;

  &:hover {
    background: none;
  }
`;

export const RequisitionListItem = styled(ListItem)`
  flex-direction: column;
  align-items: flex-start;
  padding: 0 0px 10px 0px;
`;

export const SecondaryText = styled(Typography)`
  font-size: 13px;
  color: ${theme.palette.grey[600]};
`;

export const EmptyListHelpText = styled(Typography)`
  margin-left: 12px;
  margin-top: 6px;
  font-size: 15px;
  color: ${theme.palette.grey[600]};
  font-style: italic;
`;
